import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

const { tag, env, version } = require('../../sentry-info.json');
const cid = process.env.SHOPEE_COUNTRY;

const DsnMapping = {
  id: {
    nonLive:
      'https://a338e5c7c70d46e5975ee80fe5381dec@etracking-uat1.uat.seabank.co.id/sentry/14',
    live: 'https://62484d199c8f47f1ab11ee257521ef94@etracking.seabank.co.id/sentry/6',
  },
  // TODO：需要调整
  ph: {
    nonLive:
      'https://5ea91ba749ea4f419b9a6868ecc3503e@etracking-uat1.uat.seabank.co.id/sentry/10',
    live: 'https://0e3644e8721c4239ba1ddf8fdde3e333@etracking.seabank.co.id/sentry/4',
  },
  sg: {
    nonLive:
      'https://af24626ffc3140f589acfff82603aed5@etracking-uat1.uat.maribank.com.sg/sentry/6',
    live: 'https://a6845b8d7ddd4890a80f8c2cd6905d02@etracking.maribank.com.sg/sentry/7',
  },
};

const dsn = ['live', 'dr'].includes(env)
  ? DsnMapping[cid].live
  : DsnMapping[cid].nonLive;

Sentry.init({
  dsn,
  autoSessionTracking: true,
  integrations: [new Integrations.BrowserTracing()],
  release: `${env}@${tag}`,
  dist: version,
});

export default Sentry;
